import { FormControl, Text, TextProps } from '@chakra-ui/react';
import { useCaravanDataContext } from '../CaravanDataContext';
import { useFormContext } from '../SearchFormContext';
import { BEDROOMS, MAX_PRICES, MIN_PRICES } from '../const';
import { capitalize, formatNumberWithPounds } from '../utils';
import { SelectInput } from './FormComponents';

export const CaravanFilterForm: React.FC = () => {
  const { formValues, setTempValues } = useFormContext();

  const minPricesToDisplay = isNaN(parseFloat(formValues.maxPrice))
    ? MIN_PRICES
    : MIN_PRICES.filter((price) => Number(price) < Number(formValues.maxPrice));

  const maxPricesToDisplay = isNaN(parseFloat(formValues.minPrice))
    ? MAX_PRICES
    : MAX_PRICES.filter((price) => Number(price) > Number(formValues.minPrice));

  const { countyNames } = useCaravanDataContext();

  return (
    <>
      <FormControl flex={1}>
        <FormLabel>Region</FormLabel>
        <SelectInput
          placeholder="Search by Region"
          value={formValues.county}
          onChange={(e) => setTempValues('county', e.target.value)}
        >
          {countyNames.map((county) => (
            <option value={county} key={county}>
              {capitalize(county)}
            </option>
          ))}
        </SelectInput>
      </FormControl>

      <FormControl flex={1}>
        <FormLabel>Bedrooms</FormLabel>
        <SelectInput
          placeholder="No of Bedrooms"
          value={formValues.bedrooms}
          onChange={(e) => setTempValues('bedrooms', e.target.value)}
        >
          <option value="any">Any</option>
          {BEDROOMS.map((bedroom) => (
            <option value={bedroom} key={bedroom}>
              {bedroom} +
            </option>
          ))}
        </SelectInput>
      </FormControl>

      <FormControl flex={1}>
        <FormLabel>Min Price</FormLabel>
        <SelectInput
          placeholder="Minimum Price"
          value={formValues.minPrice}
          onChange={(e) => setTempValues('minPrice', e.target.value)}
        >
          <option value="any">Any</option>
          {minPricesToDisplay.map((price) => (
            <option value={price} key={`max${price}`}>
              {formatNumberWithPounds(price)}
            </option>
          ))}
        </SelectInput>
      </FormControl>

      <FormControl flex={1}>
        <FormLabel>Max Price</FormLabel>
        <SelectInput
          placeholder="Maximum Price"
          value={formValues.maxPrice}
          onChange={(e) => setTempValues('maxPrice', e.target.value)}
        >
          <option value="any">Any</option>
          {maxPricesToDisplay.map((price) => (
            <option value={price} key={`min${price}`}>
              {formatNumberWithPounds(price)}
            </option>
          ))}
        </SelectInput>
      </FormControl>
    </>
  );
};

const FormLabel = (props: TextProps) => <Text color={{ base: 'black', md: 'white' }} {...props} />;
